/**
 * Etiquetas y estilos de los estados de la cola y de entrega de WhatsApp.
 * Debe mantenerse alineado con los enums NotificationStatus,
 * WhatsAppDeliveryStatus y NotificationType del backend
 * (api/src/modules/notifications/entities/notification-queue.entity.ts).
 */
export const QUEUE_STATUSES = [
  { value: 'pending', label: 'Pendiente', badge: 'bg-gray-100 text-gray-800' },
  { value: 'processing', label: 'Procesando', badge: 'bg-blue-100 text-blue-800' },
  { value: 'sent', label: 'Enviado', badge: 'bg-green-100 text-green-800' },
  { value: 'failed', label: 'Fallido', badge: 'bg-red-100 text-red-800' },
  { value: 'cancelled', label: 'Cancelado', badge: 'bg-amber-100 text-amber-800' },
  { value: 'resent', label: 'Reenviado', badge: 'bg-violet-100 text-violet-800' }
];

export const DELIVERY_STATUSES = [
  { value: 'accepted', label: 'Aceptado por Meta', badge: 'bg-gray-100 text-gray-800' },
  { value: 'sent', label: 'Enviado', badge: 'bg-blue-100 text-blue-800' },
  { value: 'delivered', label: 'Entregado', badge: 'bg-green-100 text-green-800' },
  { value: 'read', label: 'Leído', badge: 'bg-emerald-100 text-emerald-800' },
  { value: 'failed', label: 'Falló', badge: 'bg-red-100 text-red-800' }
];

export const NOTIFICATION_TYPES = [
  { value: 'sale_start_notification', label: 'Inicio de venta' },
  { value: 'sale_start_carrera', label: 'Inicio de venta (carrera)' },
  { value: 'access_code_delivery', label: 'Envío de código de acceso' },
  { value: 'reservation_confirmation', label: 'Confirmación de reserva' },
  { value: 'reservation_reminder', label: 'Recordatorio de reserva' },
  { value: 'reservation_payment_confirmed', label: 'Pago confirmado' },
  { value: 'reservation_tickets_retrieved', label: 'Entradas retiradas' },
  { value: 'reservation_change_notification', label: 'Cambio de reserva' },
  { value: 'reservation_final_reminder', label: 'Recordatorio final' },
  { value: 'reservation_modification_notification', label: 'Modificación de reserva' },
  { value: 'sale_start_time_correction', label: 'Corrección de horario de venta' },
  { value: 'sale_start_info_correction', label: 'Corrección de inicio de venta' }
];

const toMap = (list) =>
  list.reduce((acc, item) => {
    acc[item.value] = item;
    return acc;
  }, {});

const QUEUE_MAP = toMap(QUEUE_STATUSES);
const DELIVERY_MAP = toMap(DELIVERY_STATUSES);
const TYPE_MAP = toMap(NOTIFICATION_TYPES);

export const getQueueStatus = (value) =>
  QUEUE_MAP[value] || { value, label: value || '—', badge: 'bg-gray-100 text-gray-800' };

// Sin estado de entrega: Meta todavía no confirmó nada (o el mensaje no salió)
export const getDeliveryStatus = (value) =>
  DELIVERY_MAP[value] ||
  (value
    ? { value, label: value, badge: 'bg-gray-100 text-gray-800' }
    : { value: '', label: 'Sin confirmar', badge: 'bg-gray-50 text-gray-500' });

export const getNotificationTypeLabel = (value) => TYPE_MAP[value]?.label || value || '—';
